import React, {Component} from 'react';
import {
  Button,
  Menu,
  Dropdown,
  Slider,
  InputNumber,
  Row,
  Col
} from 'antd';
import {
  DEVICE_STATUS_COLOR_ON,
  COMMAND_OFF,
  COMMAND_ON,
  COMMAND_AIR_ON_16,
  COMMAND_AIR_ON_17,
  COMMAND_AIR_ON_18,
  COMMAND_AIR_ON_19,
  COMMAND_AIR_ON_20,
  COMMAND_AIR_ON_21,
  COMMAND_AIR_ON_22,
  COMMAND_AIR_ON_23,
  COMMAND_AIR_ON_24,
  COMMAND_AIR_ON_25,
  COMMAND_AIR_ON_26,
  COMMAND_AIR_ON_27,
  COMMAND_AIR_ON_28,
  COMMAND_AIR_ON_29,
  COMMAND_AIR_ON_30,
  COMMAND_AIR_MODE_AUTO,
  COMMAND_AIR_MODE_COOL,
  COMMAND_AIR_MODE_DRY,
  COMMAND_AIR_MODE_FAN,
  COMMAND_AIR_MODE_HEAT,
  COMMAND_AIR_WIND_AUTO,
  COMMAND_AIR_WIND_LOW,
  COMMAND_AIR_WIND_MED,
  COMMAND_AIR_WIND_HI,
  COMMAND_AIR_SWING_AUTO,
  COMMAND_AIR_SWING_1,
  COMMAND_AIR_SWING_2,
  COMMAND_AIR_SWING_3,
  COMMAND_AIR_SWING_4
} from '../constants/defaultValues'

class DeviceCmdAir extends Component {
  constructor(props) {
    super(props);
    const device = this.props.device
    this.state = {
      inputCmdAir: device.Temp
        ? device.Temp
        : 16
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.device.Temp !== nextProps.device.Temp) {
      this.setState({inputCmdAir: nextProps.device.Temp})
    }
  }

  handleMenuModeClick = (e, deviceID) => {
    const key = e.key
    if (key === "auto") {
      this.props.onCmd(deviceID, COMMAND_AIR_MODE_AUTO)
    } else if (key === "cool") {
      this.props.onCmd(deviceID, COMMAND_AIR_MODE_COOL)
    } else if (key === "dry") {
      this.props.onCmd(deviceID, COMMAND_AIR_MODE_DRY)
    } else if (key === "fan") {
      this.props.onCmd(deviceID, COMMAND_AIR_MODE_FAN)
    } else if (key === "heat") {
      this.props.onCmd(deviceID, COMMAND_AIR_MODE_HEAT)
    }
  }

  handleMenuWindClick = (e, deviceID) => {
    const key = e.key
    if (key === "auto") {
      this.props.onCmd(deviceID, COMMAND_AIR_WIND_AUTO)
    } else if (key === "low") {
      this.props.onCmd(deviceID, COMMAND_AIR_WIND_LOW)
    } else if (key === "med") {
      this.props.onCmd(deviceID, COMMAND_AIR_WIND_MED)
    } else if (key === "hi") {
      this.props.onCmd(deviceID, COMMAND_AIR_WIND_HI)
    }
  }

  handleMenuSwingClick = (e, deviceID) => {
    const key = e.key
    if (key === "auto") {
      this.props.onCmd(deviceID, COMMAND_AIR_SWING_AUTO)
    } else if (key === "1") {
      this.props.onCmd(deviceID, COMMAND_AIR_SWING_1)
    } else if (key === "2") {
      this.props.onCmd(deviceID, COMMAND_AIR_SWING_2)
    } else if (key === "3") {
      this.props.onCmd(deviceID, COMMAND_AIR_SWING_3)
    } else if (key === "4") {
      this.props.onCmd(deviceID, COMMAND_AIR_SWING_4)
    }
  }

  handleChangeAirCmd = (value, deviceID) => {
    this.setState({inputCmdAir: value});
    if (value === 16) {
      this.props.onCmd(deviceID, COMMAND_AIR_ON_16)
    } else if (value === 17) {
      this.props.onCmd(deviceID, COMMAND_AIR_ON_17)
    } else if (value === 18) {
      this.props.onCmd(deviceID, COMMAND_AIR_ON_18)
    } else if (value === 19) {
      this.props.onCmd(deviceID, COMMAND_AIR_ON_19)
    } else if (value === 20) {
      this.props.onCmd(deviceID, COMMAND_AIR_ON_20)
    } else if (value === 21) {
      this.props.onCmd(deviceID, COMMAND_AIR_ON_21)
    } else if (value === 22) {
      this.props.onCmd(deviceID, COMMAND_AIR_ON_22)
    } else if (value === 23) {
      this.props.onCmd(deviceID, COMMAND_AIR_ON_23)
    } else if (value === 24) {
      this.props.onCmd(deviceID, COMMAND_AIR_ON_24)
    } else if (value === 25) {
      this.props.onCmd(deviceID, COMMAND_AIR_ON_25)
    } else if (value === 26) {
      this.props.onCmd(deviceID, COMMAND_AIR_ON_26)
    } else if (value === 27) {
      this.props.onCmd(deviceID, COMMAND_AIR_ON_27)
    } else if (value === 28) {
      this.props.onCmd(deviceID, COMMAND_AIR_ON_28)
    } else if (value === 29) {
      this.props.onCmd(deviceID, COMMAND_AIR_ON_29)
    } else if (value === 30) {
      this.props.onCmd(deviceID, COMMAND_AIR_ON_30)
    }
  }

  handleCmdOnOff = (deviceID, cmd) => {
    this.props.onCmd(deviceID, cmd)
  }

  render() {
    const {device, sending} = this.props
    const disconnected = device.Disconnected

    const menuAuto = (<Menu onClick={(e) => this.handleMenuModeClick(e, device.DeviceId)}>
      <Menu.Item key="auto">Auto</Menu.Item>
      <Menu.Item key="cool">Cool</Menu.Item>
      <Menu.Item key="dry">Dry</Menu.Item>
      <Menu.Item key="fan">Fan</Menu.Item>
      <Menu.Item key="heat">Heat</Menu.Item>
    </Menu>);
    const menuWind = (<Menu onClick={(e) => this.handleMenuWindClick(e, device.DeviceId)}>
      <Menu.Item key="auto">Auto</Menu.Item>
      <Menu.Item key="low">Low</Menu.Item>
      <Menu.Item key="med">Med</Menu.Item>
      <Menu.Item key="hi">Hi</Menu.Item>
    </Menu>);
    const menuSwing = (<Menu onClick={(e) => this.handleMenuSwingClick(e, device.DeviceId)}>
      <Menu.Item key="auto">Auto</Menu.Item>
      <Menu.Item key="1">1</Menu.Item>
      <Menu.Item key="2">2</Menu.Item>
      <Menu.Item key="3">3</Menu.Item>
      <Menu.Item key="4">4</Menu.Item>
    </Menu>);

    return <div>
      <div>
        <Row>
          <Col span={4}></Col>
          <Col span={12}><Slider min={16} max={30} value={this.state.inputCmdAir} disabled={sending || disconnected} onChange={(value) => this.handleChangeAirCmd(value, device.DeviceId)}/>
          </Col>
          <Col span={4}>
            <InputNumber min={16} max={30} style={{
                marginLeft: 16
              }} value={this.state.inputCmdAir} disabled={sending || disconnected} onChange={(value) => this.handleChangeAirCmd(value, device.DeviceId)}/>
          </Col>
        </Row>
      </div>
      <div className="box-air">
        <div>
          <span>Mode</span>
          <Dropdown overlay={menuAuto} disabled={sending || disconnected}>
            <Button shape="circle" size="large" disabled={sending || disconnected}>
              {device.Mode}
            </Button>
          </Dropdown>
        </div>
        <div>
          <span>Wind</span>
          <Dropdown overlay={menuWind} disabled={sending || disconnected}>
            <Button shape="circle" size="large" disabled={sending || disconnected}>
              {device.Wind}
            </Button>
          </Dropdown>
        </div>
        <div>
          <span>Swing</span>
          <Dropdown overlay={menuSwing} disabled={sending || disconnected}>
            <Button shape="circle" size="large" disabled={sending || disconnected}>
              {device.Swing}
            </Button>
          </Dropdown>
        </div>
      </div>
      <div>
        <Button shape="circle" size="large" disabled={sending || disconnected} style={{
            color: DEVICE_STATUS_COLOR_ON
          }} onClick={() => this.handleCmdOnOff(device.DeviceId, COMMAND_ON)}>Bật</Button>
        <Button shape="circle" size="large" disabled={sending || disconnected} onClick={() => this.handleCmdOnOff(device.DeviceId, COMMAND_OFF)}>Tắt</Button>
      </div>
    </div>
  }
}

export default DeviceCmdAir;



// WEBPACK FOOTER //
// ./src/components/DeviceCmdAir.js